import { useIntl } from 'react-intl';
import { ButtonUI } from 'sonata-react-components';

import { groupingMessages } from '../groupingMessages';
import { GroupCountBadge } from './GroupCountBadge';

import type { GroupFamily, GroupView } from '../../domain/grouping.types';

export interface SingleGroupCardProps {
  family: GroupFamily;
  group: GroupView;
  onEdit: (groupId: string) => void;
}

/** Menu content for an item in one group: color dot, name, count and "Edit group". */
export function SingleGroupCard({ family, group, onEdit }: Readonly<SingleGroupCardProps>) {
  const { formatMessage } = useIntl();

  return (
    <div className="groupsMenu__card">
      <div className="groupsMenu__cardHeader">
        <span className="groupsMenu__dot" style={{ backgroundColor: group.color }} />
        <span className="groupsMenu__name groupsMenu__name--clamped" title={group.name}>
          {group.name}
        </span>
        <GroupCountBadge count={group.memberCount} family={family} />
      </div>
      {group.editable && (
        <ButtonUI
          className="groupsMenu__editButton"
          icon="fa-regular fa-pen-to-square"
          id={`groupsMenu-edit-${group.id}`}
          onClick={() => onEdit(group.id)}
          shape="squareRounded"
          size="ultraSmall"
          text={formatMessage(groupingMessages.editGroup)}
          type="secondary"
        />
      )}
    </div>
  );
}
